import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useTheme } from '../../contexts/ThemeContext';
import { getChartJsOptions, getChartColors } from '../../utils/themeHelpers';

interface BarChartProps {
  data: any;
  options?: any;
  plugins?: any[];
  height?: number;
  title?: string;
  className?: string;
  horizontal?: boolean;
}

const BarChart: React.FC<BarChartProps> = ({
  data,
  options = {},
  plugins = [],
  height = 320,
  title,
  className = '',
  horizontal = false
}) => {
  const { currentTheme } = useTheme();

  const defaultOptions = getChartJsOptions(currentTheme);
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: horizontal ? 'y' : 'x',
  };

  return (
    // <div className={`chart-container card-glow ${className}`}>
    //   {title && (
    //     <h3 className="title-card">{title}</h3>
    //   )}
    //   <div className="chart-wrapper" style={{ height }}>
    //     <Bar data={data} options={mergedOptions} />
    //   </div>
    // </div>
    <div className={`bar-chart-container min-w-0 w-full ${className}`}>
      {title && (
        <h3 className="title-card">{title}</h3>
      )}
      <div className="relative min-w-0" style={{ height: 350, width: '100%', padding: '20px 0' }}>
        <Bar data={data} options={mergedOptions} plugins={plugins} />
      </div>
    </div>
  );
};

export default BarChart;
